
import React from 'react';
import { Col, Row } from 'antd';
import { Card } from 'antd';
import { PieChartOutlined, FileDoneOutlined,BulbOutlined,  EnvironmentOutlined, SafetyCertificateOutlined, MonitorOutlined } from '@ant-design/icons';

const { Meta } = Card;

function Dashboard() {
	return (
		<>
			<div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
				<h1 style={{ color: '#102F10' }}>Home</h1>         
			</div>   

			<Row gutter={[32, 24]}>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/data-visualization">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<PieChartOutlined style={{ fontSize: 70 }}/>
							<Meta title="Data Visualization" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/compliance">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<SafetyCertificateOutlined style={{ fontSize: 70 }}/>
							<Meta title="Compliance and Certification" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/supply-chain-tracking">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<EnvironmentOutlined style={{ fontSize: 70 }}/>
							<Meta title="Supply Chain Tracking" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/reports">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<FileDoneOutlined style={{ fontSize: 70 }}/>
							<Meta title="Reports" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/environmental-monitoring">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<MonitorOutlined style={{ fontSize: 70 }}/>
							<Meta title="Environmental Monitoring" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
				<Col className="gutter-row"  xs={24} lg={12} xl={8} >
					<a href="/recommendations">
						<Card hoverable style={{ color: '#102F10', backgroundColor: '#ACD6AC' }}>
							<BulbOutlined style={{ fontSize: 70 }}/>
							<Meta title="Recommendations" style={{ paddingTop: '35px', fontSize: '40px !important' }}/>
						</Card>
					</a>
				</Col>
			</Row>
		</>
	);
}

export default Dashboard;